<template>
  <div
    v-if="basketList.length > 0"
    class="ecommerce-application"
  >
    <checkout />
  </div>
  <div v-else>
    <!-- Warning page-->
    <div class="misc-wrapper">
      <div class="misc-inner p-2 p-sm-3">
        <div class="w-100 text-center">
          <h2 class="mb-1">
            Sepetinizde Ürün Bulunamadı! 🕵🏻‍♀️
          </h2>
          <p class="mb-2">
            Lütfen sepetinize beğendiğiniz ürünleri ekleyin.
          </p>

          <b-button
            variant="primary"
            class="mb-2 btn-sm-block"
            :to="{path:'/'}"
          >
            Anasayfaya Dön
          </b-button>

        </div>
      </div>
    </div>
    <!-- / Warning page-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { BButton } from 'bootstrap-vue'
import Checkout from './apps/e-commerce/e-commerce-checkout/ECommerceCheckout.vue'

export default {
  components: {
    Checkout,
    BButton,
  },
  computed: {
    ...mapGetters({
      basketList: 'eCommerce/getBasketList',
    }),
  },
}
</script>

<style>

</style>
